// ============================================================
// MENU DRAWER — tabs + expandable rows + newsletter (Nicobar mobile-nav)
// Rebuilds the drawer's link list into a tab row (Shop · Collections ·
// Our Story · Help) with one panel per tab. Every link is read from the
// desktop header's own dropdowns (and the drawer's collection rows), so
// the two menus never drift apart. The top bar, utility list and social
// icons already in the drawer are kept; a Bag icon is added to the top bar
// and a newsletter block (same Shopify form the footer uses) goes last.
// The menu opens directly BELOW the announcement bar, which stays visible
// and keeps scrolling.
// ============================================================
(function () {
  var overlay = document.getElementById('menu-overlay');
  var drawer = overlay && overlay.querySelector('.menu-drawer');
  var hdr = drawer && drawer.querySelector('.menu-drawer__hdr');
  var scroller = drawer && drawer.querySelector('.menu-drawer__scroll');
  var oldNav = scroller && scroller.querySelector('.menu-drawer__nav');
  if (!oldNav || !hdr || drawer.querySelector('.menu-drawer__tabs')) return;

  function slice(list) { return Array.prototype.slice.call(list); }

  function headerLinks(id) {
    var wrap = document.getElementById(id);
    if (!wrap) return [];
    return slice(wrap.querySelectorAll('a.subnav-linkdrop__item')).map(function (a) {
      var l = a.querySelector('.subnav-linkdrop__label');
      return { href: a.getAttribute('href'), label: (l || a).textContent.replace(/\s+/g, ' ').trim() };
    });
  }

  var edits = slice(oldNav.querySelectorAll('a')).filter(function (a) {
    return /\/collections\/(bagh|rozana)/.test(a.getAttribute('href') || '');
  }).map(function (a) {
    var href = a.getAttribute('href');
    return { href: href, label: a.textContent.replace(/\s+/g, ' ').trim() };
  });

  var tabs = [
    {
      id: 'shop', label: 'Shop',
      rows: headerLinks('shop-category-linkdrop').concat([
        { label: 'Shop by Pattern', children: headerLinks('shop-pattern-linkdrop') }
      ])
    },
    { id: 'collections', label: 'Collections', rows: edits.concat([{ href: '/collections', label: 'All Collections' }]) },
    { id: 'story', label: 'Our Story', rows: headerLinks('our-story-linkdrop') },
    { id: 'help', label: 'Help', rows: headerLinks('customer-care-linkdrop') }
  ].filter(function (t) {
    t.rows = t.rows.filter(function (r) { return r.href || (r.children && r.children.length); });
    return t.rows.length;
  });
  if (!tabs.length) return;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }
  function link(item, cls) {
    var a = el('a', cls);
    a.href = item.href;
    a.appendChild(document.createTextNode(item.label));
    return a;
  }

  // ---- Tab row + panels ----
  var tabRow = el('div', 'menu-drawer__tabs');
  tabRow.setAttribute('role', 'tablist');
  var nav = el('nav', 'menu-drawer__nav');
  nav.setAttribute('aria-label', 'Shop');

  var tabEls = [], panelEls = [];
  tabs.forEach(function (t, i) {
    var btn = el('button', 'menu-drawer__tab' + (i === 0 ? ' is-active' : ''), t.label);
    btn.type = 'button';
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    tabRow.appendChild(btn);
    tabEls.push(btn);

    var panel = el('div', 'menu-drawer__panel' + (i === 0 ? ' is-active' : ''));
    panel.setAttribute('role', 'tabpanel');
    t.rows.forEach(function (r) {
      if (r.children) {
        var toggle = el('button', 'menu-drawer__row menu-drawer__row--toggle');
        toggle.type = 'button';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.appendChild(document.createTextNode(r.label));
        toggle.appendChild(el('span', 'menu-drawer__plus'));
        var sub = el('div', 'menu-drawer__sub');
        r.children.forEach(function (c) { sub.appendChild(link(c, 'menu-drawer__row menu-drawer__row--sub')); });
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          sub.classList.toggle('is-open', open);
        });
        panel.appendChild(toggle);
        panel.appendChild(sub);
      } else {
        var a = link(r, 'menu-drawer__row');
        panel.appendChild(a);
      }
    });
    nav.appendChild(panel);
    panelEls.push(panel);

    btn.addEventListener('click', function () {
      tabEls.forEach(function (b, j) {
        var on = j === i;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        panelEls[j].classList.toggle('is-active', on);
      });
      scroller.scrollTop = 0;
    });
  });

  hdr.parentNode.insertBefore(tabRow, hdr.nextSibling);
  scroller.replaceChild(nav, oldNav);

  // ---- Bag icon in the top bar (opens the cart drawer) ----
  var icons = hdr.querySelector('.menu-drawer__hdr-icons');
  var cartBtn = document.getElementById('cart-open-btn');
  var cartSvg = cartBtn && cartBtn.querySelector('svg');
  if (icons && cartBtn && cartSvg) {
    var bag = el('button', 'menu-drawer__hdr-icon');
    bag.type = 'button';
    bag.setAttribute('aria-label', 'Bag');
    var svg = cartSvg.cloneNode(true);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    bag.appendChild(svg);
    bag.addEventListener('click', function () {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      cartBtn.click();
    });
    icons.appendChild(bag);
  }

  // ---- Newsletter (same fields and copy as the footer's form) ----
  var news = el('div', 'menu-drawer__news');
  news.appendChild(el('p', 'menu-drawer__news-title', 'Get on the list'));
  news.appendChild(el('p', 'menu-drawer__news-copy',
    'Be the first to know about new edits, restocks and stories from the artisans who print them in Jaipur.'));

  var form = el('form', 'menu-drawer__news-form');
  form.method = 'post';
  form.action = '/contact#menu-newsletter';
  form.setAttribute('accept-charset', 'UTF-8');
  [['form_type', 'customer'], ['utf8', '✓'], ['contact[tags]', 'newsletter']].forEach(function (f) {
    var h = document.createElement('input');
    h.type = 'hidden';
    h.name = f[0];
    h.value = f[1];
    form.appendChild(h);
  });
  var input = el('input', 'menu-drawer__news-input');
  input.type = 'email';
  input.name = 'contact[email]';
  input.required = true;
  input.autocomplete = 'email';
  input.placeholder = 'Enter your email address here';
  input.setAttribute('aria-label', 'Email address');
  var submit = el('button', 'menu-drawer__news-btn', 'Submit');
  submit.type = 'submit';
  form.appendChild(input);
  form.appendChild(submit);
  news.appendChild(form);

  // Stay in the drawer when we can; if anything looks off (network error,
  // Shopify's bot check), fall back to the normal form post like the footer.
  form.addEventListener('submit', function (e) {
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    submit.disabled = true;
    fetch('/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok || (res.url || '').indexOf('/challenge') !== -1) throw new Error('fallback');
        var msg = el('p', 'menu-drawer__news-msg', 'Thank you. You’re on the list.');
        news.replaceChild(msg, form);
      })
      .catch(function () {
        submit.disabled = false;
        form.submit();
      });
  });

  var foot = scroller.querySelector('.menu-drawer__foot');
  scroller.insertBefore(news, foot ? foot.nextSibling : null);

  // ---- Open BELOW the announcement bar ----
  // The bar sits in the fixed header block at the very top of the screen and
  // its ticker keeps running. The menu layer starts at the bar's bottom edge
  // (measured each time the menu opens, so it stays right if the bar's height
  // changes or the bar is switched off); menu-drawer.css reads --dt-menu-top.
  var bar = document.querySelector('.announcement-bar');
  function placeBelowBar() {
    var top = 0;
    if (bar) {
      var r = bar.getBoundingClientRect();
      if (r.height) top = Math.max(0, Math.round(r.bottom));
    }
    overlay.style.setProperty('--dt-menu-top', top + 'px');
  }
  placeBelowBar();
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (overlay.classList.contains('open')) placeBelowBar();
    }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
  }
  window.addEventListener('resize', function () {
    if (overlay.classList.contains('open')) placeBelowBar();
  });
})();
